import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getOffices = () =>
  graphqlHelper({
    query: graphql.office.queries.get,
    variables: {},
  });

export {
  // eslint-disable-next-line import/prefer-default-export
  getOffices,
};



// WEBPACK FOOTER //
// ./src/services/office.js